<template lang="pug">
    .delivery-from
        z-select(
            label="Способ отправки груза"
            v-model="deal.delivery_method_from"
            :required="true"
            name="delivery_method_from"
            id="delivery_method_from"
            v-validate="'required'"
            v-bind:error="errors.first('delivery_method_from')"
            data-vv-name="delivery_method_from"
            v-bind:data-vv-as="' '"
            v-bind:disabled="$props.isUserAgentForm || blocked"
            inline
            v-bind:dirty.sync="dirtyObj.method"
        )
            option(v-bind:value="1") С терминала
            option(v-bind:value="2" v-on:click="deal.from_stock_id = null") С адреса клиента

        div(v-if="stocks && stocks.length && parseInt(deal.delivery_method_from) === 1")
            z-select(
                label="Склад"
                v-model="deal.from_stock_id"
                :required="true"
                name="from_stock"
                id="from_stock"
                v-validate="'required'"
                v-bind:error="errors.first('from_stock')"
                data-vv-name="from_stock"
                v-bind:data-vv-as="' '"
                v-bind:disabled="blocked"
                inline
                v-bind:dirty.sync="dirtyObj.stock"
            )
                option(v-for="stock in stocks" v-bind:value="stock.id" v-bind:key="stock.id" v-bind:disabled="stock.disabled") {{ stock.name }}

        div(v-if="parseInt(deal.delivery_method_from) === 2")
            ZInputAutocomplete(
                v-if="deal.from_address && deal.from_address.address !== undefined"
                label="Введите точный адрес"
                display-property="unrestricted_value"
                property="unrestricted_value"
                return="unrestricted_value"
                v-model="deal.from_address.address"
                v-bind:showOnFocus="true"
                v-bind:callback="suggestAddress"
                v-bind:items="addressSuggest"
                v-bind:default="deal.from_address.address"
                v-on:select="selectAddress"
                v-on:clear="clearAddress"
                :required="true"
                id="from_address"
                name="from_address"
                
                data-vv-name="from_address"
                v-bind:data-vv-as="' '"
                v-validate="{'required': true}"
                v-bind:error="errors.first('from_address')"

                v-bind:disabled="blocked"
                v-bind:dirty.sync="dirtyObj.address"
            )

            .md-layout-item
                z-select(
                    v-if="$props.payers"
                    label="Плательщик (экспедир.)"
                    v-model="deal.forwarding_payer_id_from"
                    v-bind:name="('forwarding-from-payer')"
                    v-bind:id="('forwarding-from-payer-')"
                    v-bind:disabled="blocked"
                    v-bind:inline="true"
                    v-bind:dirty.sync="dirtyObj.payer"

                    data-vv-name="forwarding_payer_id_from"
                    v-bind:data-vv-as="' '"
                    v-bind:error="errors.first('forwarding_payer_id_from')"
                )
                    option(v-for="(payer, i) in $props.payers" v-bind:disabled="!payer.id" v-bind:key="(payer.hid + '-' + i)" v-bind:value="payer.id") {{payer.name}}
            .md-layout-item
                z-input(
                    label="Цена экспедирования"
                    v-model="deal.custom_forward_price_from"
                    name="custom_forward_price_from"
                    id="custom_forward_price_from"
                    type="number"
                    v-bind:placeholder="getForwardingFullPrice()"
                    v-bind:error="errors.first('custom_forward_price_from')"
                    data-vv-name="custom_forward_price_from"
                    v-bind:data-vv-as="' '"
                    v-bind:disabled="blocked || !$props.canEditPrice"
                    inline
                    v-bind:dirty.sync="dirtyObj.forward_price_from"
                )

            .md-layout-item
                z-date(
                    label="Желаемая дата забора"
                    v-model="deal.forwarding_date_from"
                    required inline
                    data-vv-name="forwarding_date_from"
                    v-bind:data-vv-as="' '"
                    v-validate="{'required': true}"
                    v-bind:error="errors.first('forwarding_date_from')"
                    v-bind:dirty.sync="dirtyObj.date"
                    v-bind:disabled="blocked"
                )
                
                //md-field(v-bind:class="{ 'md-invalid': errors.has('forwarding_date_from'), 'md-has-value': deal.forwarding_date_from}")
                    label Желаемая дата забора*
                    datetime(
                        name="forwarding_date_from"
                        v-validate="parseInt(deal.delivery_method_from) == 2 ? 'required' : ''"
                        v-model="deal.forwarding_date_from"
                        input-class="md-input"
                        type="date"
                        v-bind:use12-hour="false"
                        v-bind:week-start="1"
                        v-bind:phrases="{ ok: 'Ок', cancel: 'Отмена' }"
                        data-vv-name="forwarding_date_from"
                        v-bind:data-vv-as="' '"
                        v-bind:disabled="blocked"
                    )
                    span.md-error(v-show="errors.has('forwarding_date_from')") {{ errors.first('forwarding_date_from') }}

            .md-layout-item.static-container(v-if="deal && deal.route_list_from")
                .static-item(v-if="deal.route_list_from.date")
                    label Дата забора (по маршрутному листу)
                    .field {{moment(deal.route_list_from.date).tz($root.userTimezone).format('DD.MM.YYYY (DD MMMM)')}}
                .static-item(v-if="deal.route_list_from.forwarder && deal.route_list_from.forwarder.login")
                    label Экспедитор в пункте забора (по маршрутному листу)
                    .field {{deal.route_list_from.forwarder.login}}

        .signature-buttons
            div(v-if="parseInt(deal.delivery_method_from) === 1")
                md-field(v-show="deal.id && deal.id != 'new' && !!deal.from_stock_signature" v-bind:class="{ 'md-invalid': errors.has('from_stock_signature'), 'md-has-value': !!deal.from_stock}")
                    label(v-html=" 'Склад' + ' <b>' + ((deal.from_stock_signature_date) ? '(' + moment(deal.from_stock_signature_date).tz($root.userTimezone).format('DD.MM.YYYY HH:mm') + ')' : '') + '</b>' ")
                    wacom-signature(ref="fromStockSignature" v-model="deal.from_stock_signature" v-on:capture-complete="onFromStockCapture")
                z-button(v-on:click="doFromStockCapture()" v-if="deal.id && deal.id != 'new' && !blocked" light) Подпись на складе
                
            div
                md-field(v-show="deal.id && deal.id != 'new' && !!deal.from_signature" v-bind:class="{ 'md-invalid': errors.has('from_signature'), 'md-has-value': !!deal.from_signature}")
                    label(v-html="((parseInt(deal.delivery_method_from) === 1) ? 'Терминал'  : 'Отправитель ' ) + ' <b>' + ((deal.from_signature_date) ? '(' + moment(deal.from_signature_date).tz($root.userTimezone).format('DD.MM.YYYY HH:mm') + ')' : '') + '</b>' ")
                    wacom-signature(ref="fromSignature" v-model="deal.from_signature" v-on:capture-complete="onFromCapture")
                z-button(v-on:click="doFromCapture()" v-if="deal.id && deal.id != 'new' && !blocked" light) Подпись на терминале

        //Подпись представителя
        wacom-signature(ref="agentSignature" v-model="deal.from_signature" v-on:capture-complete="onAgentCaptureComplete" v-on:capture-cancel="onAgentCaptureCancel" style="display: none;")
</template>
<script>
    import ZInputAutocomplete from '@/components/ZInputAutocomplete'
    import moment from "moment"
    import Properties from '@/components/Properties'
    import WacomSignature from '@/components/WacomSignature';
    import ZSelect from '@/components/ZSelect';
    import ZInput from '@/components/ZInput';
    import ZDate from '@/components/ZDate';
    import ZButton from '@/components/ZButton';
    export default {
        name: 'delivery-from',
        props: {
            value: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            isUserAgentForm: {
                type: Boolean,
                default: false
            },
            block: {
                type: Boolean,
                default: false
            },
            suggestAddressCallback: {
                type: Function,
                default: () => {}
            },
            payers: {
                type: Array,
                default: []
            },
            dirty: {
                type: Boolean,
                default: false
            },
            canEditPrice: {
                type: Boolean,
                default: true
            },

            isUserHasHighPermission: {
                type: Boolean,
                default: false
            },
            isUserAgent: {
                type: Boolean,
                default: false
            },
            isUserAdmin: {
                type: Boolean,
                default: false
            },
            isUserManager: {
                type: Boolean,
                default: false
            },

            isDealCanceled: {
                type: Boolean,
                default: false
            },
            isIssueToTransfer: {
                type: Boolean,
                default: false
            },
            isEnteredToStock: {
                type: Boolean,
                default: false
            },
            isIssusedToClient: {
                type: Boolean,
                default: false
            },
        },
        components: {
            ZInputAutocomplete,
            WacomSignature,
            ZDate,
            ZSelect,
            ZButton,
            ZInput
        },
        data() {
            return {
                parent: null,
                method: 1,
                deal: {},
                defaultAddress: {
                    id: null,
                    value: {},
                    address: null,
                    description: null,
                    type_id: 1,
                    city_id: null,
                    value: {
                        city_fias_id: null
                    }
                },
                defaultStock: {
                    id: null,
                    name: null,
                    description: null,
                    sort: 100,
                    city_id: null,
                    freight_count: 0
                },
                dirtyObj: {
                    method: false,
                    stock: false,
                    address: false,
                    date: false,
                    forward_price_from: false,
                    payer: false
                }
            }
        },
        computed: {
            blocked() {
                // Если пользователь администратор, то он всегда может редактировать параметры отправления
                if (this.$props.isUserAdmin) return false;

                // Остальные условия сработают только для представителя и менеджера

                // Если заявка отменена, то ничего редактировать нельзя
                if (this.$props.isDealCanceled) return true;

                // Если заявка выдана клиенту и пользователь не админ, тогда он не может редактировать параметры отправления
                if (this.$props.isIssusedToClient && !this.$props.isUserAdmin) return true;

                // Если заявка была выдана на перемещение или принята с перемещения, то менять параметры отправления может только админ или менеджер
                if ((this.$props.isIssueToTransfer || this.$props.isEnteredToStock) && !this.$props.isUserAdmin && !this.isUserManager) return true;
            },
            stocks() {
                const fromStockIds = this.fromStocks.map(stock => stock.id);
                return this.allStocks.map(stock => {
                    stock.disabled = !(fromStockIds.indexOf(stock.id)+1);
                    return stock;
                });
            },
            fromStocks() {
                return this.$store.state.stock.from_stocks || [];
            },
            allStocks() {
                // Используем to_stocks чтобы получить список всех складов,
                // а не только тех, которые доступны пользователю
                return this.$store.state.stock.to_stocks || [];
            },
            addressTypes() {
              return this.$store.state.address.address_types;
            },
            addressSuggest() {
                if (!this.deal.sender || !this.deal.sender.addresses) return [];
                else return this.deal.sender.addresses.map(item => {
                    return {
                        id: item.id,
                        data: item.value,
                        value: item.address,
                        unrestricted_value: item.address
                    };
                });
            },
            defaultPayer() {
                if (!this.$props.payers || !this.$props.payers.length) return;
                return this.$props.payers.find(p => !!p);
            },
            isDirty() {
                return !!Object.values(this.dirtyObj).find(item => item);
            }
        },
        watch: {
            '$props.value': {
                deep: true,
                handler() {
                    this.init();
                }
            },
            '$props.payers': {
                deep: true,
                handler() {
                    this.setDefaultPayer();
                }
            },
            'deal': {
                deep: true,
                handler(deal) {
                    this.$emit('change', deal);
                    this.$emit('input', deal);
                }
            },
            'deal.delivery_method_from'(method) {
                //Метод - со склада
                if (parseInt(method) == 1) {
                    this.deal.from_address_id = null;
                    this.deal.custom_forward_price_from = null;
                    //this.deal.from_address = Object.assign({}, this.defaultAddress);
                //Метод - с адреса клиента
                } else if (parseInt(method) == 2) {
                    this.deal.from_stock_id = null;
                    //this.deal.from_stock = Object.assign({}, this.defaultStock);
                }
                this.setDefaultPayer();
            },
            'isDirty'(val) {
                if (val) this.emitDirty();
            }
        },
        methods: {
            emitDirty() {
                this.$emit('update:dirty', this.isDirty);
            },
            init() {
                if (this.$props.value && JSON.stringify(this.$props.value) != JSON.stringify(this.deal)) this.deal = Object.assign({}, this.$props.value);
                if (!deal.delivery_method_from) deal.delivery_method_from = 1;
                this.validateClear();
                this.setDefaultPayer();
            },

            setDefaultPayer() {
                if (parseInt(this.deal.delivery_method_from) === 1)
                    return this.deal.forwarding_payer_id_from = null;

                if (!this.defaultPayer)
                    return this.deal.forwarding_payer_id_from = null;

                if (this.deal.forwarding_payer_id_from) {
                    let exist = this.$props.payers.find(item => parseInt(item.id) === parseInt(this.deal.forwarding_payer_id_from));
                    if (exist) return;
                    this.deal.forwarding_payer_id_from = null;
                }

                this.deal.forwarding_payer_id_from = this.defaultPayer.id;
            },

            validateClear() {
                this.errors.clear();
                this.$validator.errors.clear();
                this.$validator.reset();
            },
            suggestAddress(string) {
                return this.suggestAddressCallback(string);
            },
            selectAddress(address, item) {
                if ((!item.id || item.id === 'new') && this.addressTypes && this.addressTypes.length) {
                    let type = this.addressTypes.find(item => item.code == 'order');
                    this.deal.from_address.type_id = type.id;
                    delete this.deal.from_address.id;
                }
                if (item.id) this.deal.from_address_id = item.id;
                else this.deal.from_address_id = 'new';

                if (item.data && item.data.city_fias_id) this.deal.from_address.value.city_fias_id = item.data.city_fias_id;
                else this.deal.from_address.value.city_fias_id = null;
            },
            clearAddress() {
                this.deal.from_address_id = null;
                this.deal.from_address    = Object.assign({}, this.defaultAddress);
            },

            getForwardingFullPrice() {
                if (
                    this.deal && this.deal.first_freight && this.deal.first_freight.full_price && 
                    this.deal.first_freight.full_price.additional && this.deal.first_freight.full_price.additional.forwarding_from
                ) return ('Текущая: ' + this.$parent.formatPrice(this.deal.first_freight.full_price.additional.forwarding_from.value)  + ' руб.');

                return '';
            },



            doAgentCapture() {
                this.$off('onAgentCaptureComplete');
                this.$off('onAgentCaptureCancel');
                return new Promise((resolve, reject) => {
                    if (!this.$refs || !this.$refs.agentSignature) {
                        if (reject) reject();
                        else return;
                    }

                    this.$refs.agentSignature.$emit('capture');
                    this.$once('onAgentCaptureComplete', () => {
                        this.deal.from_stock_signature = this.deal.from_signature;
                        this.$nextTick(() => resolve(this.deal.from_signature));
                    });
                    this.$once('onAgentCaptureCancel', () => {
                        if (reject) reject();
                    });
                });
            },
            onAgentCaptureComplete() {
                this.$emit('onAgentCaptureComplete');
                this.$off('onAgentCaptureComplete');
            },
            onAgentCaptureCancel() {
                this.$emit('onAgentCaptureCancel');
                this.$off('onAgentCaptureCancel');
            },



            doFromStockCapture() {
                if (!this.$refs || !this.$refs.fromStockSignature) return;
                this.$refs.fromStockSignature.$emit('capture');
            },
            doFromCapture() {
                if (!this.$refs || !this.$refs.fromSignature) return;
                this.$refs.fromSignature.$emit('capture');
            },
            onFromStockCapture() {
                this.$nextTick(() => {
                    let data = {
                        deal_id: this.deal.id,
                        type: 'from_stock_signature',
                        signature: this.deal.from_stock_signature,
                        signature_all_freight: 1
                    };
                    this.$store.commit('showProgressBar', 'load-deal-card');
                    this.$store.dispatch('deals/setDealCapture', data).then(() => {
                      this.$store.commit('showSnackbar', ['Заявка и грузы успешно подписаны в пункте отправления, на складе', 6000, 'success']);
                    }).finally(() => this.$store.commit('hideProgressBar', 'load-deal-card'));
                });
            },
            onFromCapture() {
                this.$nextTick(() => {
                    let data = {
                        deal_id: this.deal.id,
                        type: 'from_signature',
                        signature: this.deal.from_signature,
                        signature_all_freight: 1
                    };
                    this.$store.commit('showProgressBar', 'load-deal-card');
                    this.$store.dispatch('deals/setDealCapture', data).then(() => {
                      this.$store.commit('showSnackbar', ['Заявка и грузы успешно подписаны в пункте отправления', 6000, 'success']);
                    }).finally(() => this.$store.commit('hideProgressBar', 'load-deal-card'));
                });
            },
            validate() {
                return this.$validator.validateAll();
            }           
        },
        created() {
            this.$nextTick(() => this.init());
        },
    }
</script>
<style lang="sass">
</style>


// WEBPACK FOOTER //
// DeliveryFrom.vue?a0bab368